import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";
import { cursor, opacity } from "theme";

import { faCircle as iconDot } from "@fortawesome/pro-duotone-svg-icons";
import { faCircle as iconCircle } from "@fortawesome/pro-regular-svg-icons";
import { faDotCircle } from "@fortawesome/pro-solid-svg-icons";

import FnrFade from "UI/FnrFade/FnrFade";
import FnrLoadingBricks from "UI/FnrLoadingBricks";

ExpandingRadioButtonOption.propTypes = {
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
  subLabel: PropTypes.string,
  isLoading: PropTypes.bool,
  marginRight: PropTypes.number,
  className: PropTypes.string,
  activeCircle: PropTypes.oneOf(["dot", "dotCircle"]),
  iconColor: PropTypes.string,
  children: PropTypes.any,
};
export function ExpandingRadioButtonOption({
  isActive,
  onClick = () => {},
  isLoading,
  label,
  subLabel,
  marginRight,
  className,
  style,
  fontSize,
  loadingColor = "gray",
  activeCircle = "dot",
  iconColor,
  noMargin,
  disabled,
  children,
}) {
  const activeCircleIcon = activeCircle === "dotCircle" ? faDotCircle : iconDot;
  const handleClick = () => {
    if (!disabled && onClick) onClick();
  };
  return (
    <Wrapper className={className} style={style} $noMargin={noMargin}>
      <Clickable
        onClick={handleClick}
        $variant={disabled ? "disabled" : undefined}
      >
        <Icon marginRight={marginRight} iconColor={iconColor}>
          {isLoading ? (
            <FnrLoadingBricks show={true} color={loadingColor} size={19} />
          ) : (
            <FontAwesomeIcon icon={isActive ? activeCircleIcon : iconCircle} />
          )}
        </Icon>
        <Label fontSize={fontSize}>{label}</Label>
        {subLabel ? <SubLabel>{subLabel}</SubLabel> : null}
      </Clickable>

      <FnrFade show={children && isActive}>
        <div style={{ marginLeft: "27px" }}>{children}</div>
      </FnrFade>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  ${({ $noMargin }) => ($noMargin ? "" : `margin: 10px 0;`)}
`;
const Clickable = styled.div`
  ${cursor}
  ${opacity}
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
const Icon = styled.div`
  font-size: 21px;
  margin-right: ${({ marginRight }) =>
    marginRight ? `${marginRight}px` : "6px"};
  width: 21px;
  height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({
    iconColor,
    theme: {
      colors: { fnDarkBlue },
    },
  }) => iconColor || fnDarkBlue};
`;
const Label = styled.div`
  font-size: ${({ fontSize }) => fontSize}px;
  margin: 3px 0;
  font-weight: 400;
`;
const SubLabel = styled.div`
  font-size: 15px;
  color: #828c8d;
  width: 100%;
  padding-left: 28px;
  box-sizing: border-box;
  font-weight: 400;
`;
